document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');

function setMenu(open) {
  if (!menuToggle || !mobileNav) return;
  mobileNav.toggleAttribute('hidden', !open);
  menuToggle.setAttribute('aria-expanded', String(open));
  menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  menuToggle.textContent = open ? '×' : '☰';
}

menuToggle?.addEventListener('click', () => {
  setMenu(mobileNav?.hasAttribute('hidden'));
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && mobileNav && !mobileNav.hasAttribute('hidden')) {
    setMenu(false);
    menuToggle?.focus();
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const option = select.options[select.selectedIndex];
  const price = document.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});


const imageLightbox = document.querySelector('[data-image-lightbox]');
const lightboxImage = imageLightbox?.querySelector('[data-image-lightbox-image]');
const lightboxCaption = imageLightbox?.querySelector('[data-image-lightbox-caption]');
const lightboxClose = imageLightbox?.querySelector('[data-image-lightbox-close]');
let lastImageTrigger = null;

function openImageLightbox(trigger) {
  if (!imageLightbox || !lightboxImage || !trigger) return;

  const source = trigger.dataset.zoomSrc;
  const alt = trigger.dataset.zoomAlt || '';
  if (!source) return;

  lastImageTrigger = trigger;
  lightboxImage.src = source;
  lightboxImage.alt = alt;
  if (lightboxCaption) lightboxCaption.textContent = alt;
  document.body.classList.add('lightbox-open');

  if (typeof imageLightbox.showModal === 'function') {
    imageLightbox.showModal();
  } else {
    imageLightbox.setAttribute('open', '');
  }
  lightboxClose?.focus();
}

function resetImageLightbox() {
  document.body.classList.remove('lightbox-open');
  if (lightboxImage) {
    lightboxImage.removeAttribute('src');
    lightboxImage.alt = '';
  }
  if (lightboxCaption) lightboxCaption.textContent = '';
  lastImageTrigger?.focus();
  lastImageTrigger = null;
}

function closeImageLightbox() {
  if (!imageLightbox) return;

  if (typeof imageLightbox.close === 'function' && imageLightbox.open) {
    imageLightbox.close();
  } else {
    imageLightbox.removeAttribute('open');
    resetImageLightbox();
  }
}

document.addEventListener('click', (event) => {
  const imageTrigger = event.target.closest('[data-image-zoom]');
  if (imageTrigger) {
    openImageLightbox(imageTrigger);
    return;
  }

  if (event.target.closest('[data-image-lightbox-close]')) {
    closeImageLightbox();
  }
});

imageLightbox?.addEventListener('click', (event) => {
  if (event.target === imageLightbox) closeImageLightbox();
});

imageLightbox?.addEventListener('close', resetImageLightbox);

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && imageLightbox?.hasAttribute('open') && typeof imageLightbox.close !== 'function') {
    closeImageLightbox();
  }
});
